export default interface IApplication {
    firstName: "";
    lastName: "";
    emailAddress: "";
    phoneNumber: "";
    location: "";
    vacancy: -1;
    otherVacancy: "";
    status: "";
    expectation: 0;
    gender: "";
    agree: boolean;
    skill_dotnet: boolean;
    skill_sql: boolean;
    skill_m365_consultancy: boolean;
    skill_m365_management: boolean;
    skill_spfx: boolean;
    skill_az: boolean;
    skill_unit_testing: boolean;
    skill_pbi: boolean;
    skill_papps: boolean;
    skill_msflow: boolean;
    skill_documentation: boolean;
    skill_pm: boolean;
    skill_sales_marketing: boolean;
    skill_itsupport: boolean;
    skill_other: string;
}

export const NewApplication: IApplication = {
    firstName: "",
    lastName: "",
    emailAddress: "",
    phoneNumber: "",
    location: "",
    vacancy: -1,
    otherVacancy: "",
    status: "",
    expectation: 0,
    gender: "",
    agree: false,
    skill_dotnet: false,
    skill_sql: false,
    skill_m365_consultancy: false,
    skill_m365_management: false,
    skill_spfx: false,
    skill_az: false,
    skill_unit_testing: false,
    skill_pbi: false,
    skill_papps: false,
    skill_msflow: false,
    skill_documentation: false,
    skill_pm: false,
    skill_sales_marketing: false,
    skill_itsupport: false,
    skill_other: "",
};